import { connect } from 'react-redux';

import { editCrewModalConfirm, editCrewModalUpdate, toggleCrewModal } from '../../../redux/modals';
import CrewModal from './CrewModal';

const mapStateToProps = (state) => state.modals.crewModal;

const mapDispatchToProps = {
  onChange: editCrewModalUpdate,
  onConfirm: editCrewModalConfirm,
  onHide: () => toggleCrewModal()
};

export default connect(mapStateToProps, mapDispatchToProps)(CrewModal);
